import { HeaderValues } from 'src/Utils/csv/csv.constants'

export interface ImportFrameworkSectionsCSVRow {
  requirementName: string
  requirementDetails: string
  sectionName: string
  sectionDetails: string
  controlMappings: string[]
}

export const FRAMEWORK_SECTIONS_CSV_HEADERS: HeaderValues[] = [
  { input: 'requirement_name', output: 'requirementName' },
  {
    input: 'requirement_details',
    output: 'requirementDetails',
    optional: true,
  },
  { input: 'section_name', output: 'sectionName' },
  {
    input: 'section_details',
    output: 'sectionDetails',
    optional: true,
  },
  { input: 'control_mappings', output: 'controlMappings', optional: true },
]

export const FRAMEWORK_SECTIONS_CSV_TEMPLATE = [
  {
    requirement_name: 'Access reviews',
    requirement_details: 'Periodic access reviews are performed.',
    section_name: 'Access control',
    section_details: 'Controls for logical and physical access.',
    control_mappings: '',
  },
  {
    requirement_name: 'Encryption in transit',
    requirement_details: 'Data is encrypted using TLS.',
    section_name: 'Security',
    section_details: 'Controls for data encryption and transmission.',
    control_mappings: '',
  },
]
